export const liff = (window as any).liff;